/** @jsxImportSource @emotion/react */

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import Login from "./pages/Login";
import { css } from "@emotion/react";
import { PALETTE, SIZE } from "styles/base/variables";
import RouteTracker from "components/Router/Tracker";
import SignUp from "pages/SignUp";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Layout>
      <BrowserRouter>
        <RouteTracker />

        <Routes>
          <Route path="/*" element={<App />} />
          <Route path="/login" element={<Login />} />
          <Route path="/sign-up" element={<SignUp />} />
        </Routes>
      </BrowserRouter>
    </Layout>
  </React.StrictMode>
);

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div
      css={css`
        min-height: calc(100vh - 15px); // 15px is the height of the scrollbar
        min-width: ${SIZE.minWidth}px;
        background-color: ${PALETTE.background};
      `}
    >
      {children}
    </div>
  );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
